// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeMessageEditBody = {
  messageId: string;
  body: string;
};

export type typeMessageEditOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { messageId: string; editedAtIso: string };
};

export type typeMessageEditOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMessageEditOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMessageEditOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaMessageEditBody = {
  type: "object",
  properties: {
    messageId: { type: "string", maxLength: 3000, minLength: 1 },
    body: { type: "string", maxLength: 10000, minLength: 1 },
  },
  required: ["messageId", "body"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createMessageEdit(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaMessageEditBody);
  }

  return async function postMessageEdit(
    payload: typeMessageEditBody,
  ): Promise<typeMessageEditOutput200 | typeMessageEditOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postMessageEdit" failed before calling the network. #348271964156`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#348271964156" },
        },
        data: null,
      } as typeMessageEditOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/message/edit`,
      httpMethod: "POST",
      options,
    })) as typeMessageEditOutput200 | typeMessageEditOutput400;
  };
}
